import { Box, Typography } from '@mui/material';

import { EpisodeRelevance } from '@/types';

export const EpisodeRelevanceTooltip = ({
  relevance,
}: {
  relevance?: EpisodeRelevance;
}) => {
  if (!relevance) return null;

  return (
    <Box
      sx={{
        p: 1,
        '& > *': { color: 'text.contrast' },
      }}>
      <Typography sx={{ mb: 1 }} variant="body2">
        <b>Total boost:</b> {relevance.totalBoost}
      </Typography>
      {Object.entries(relevance.boostDetails).map(([key, value]) => (
        <Typography variant="body3" key={key}>
          {key}: {value}
        </Typography>
      ))}
    </Box>
  );
};
